module.exports = __webpack_public_path__ + "static/images/smartspot-performance-fr-FR.1f944922d1dc081cfdc99b17be7fb674.png";